import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Auditor } from "@app/Domain/Models/auditor.model";
import { SurveyAuditor } from "@app/Domain/Models/surveyAuditor.model";
import { environment } from "environments/environments";
import { Observable, Subject, tap } from "rxjs";
import { BaseService } from "./base.service";
import { SessionStorageService } from "./session-storage.service";

@Injectable({
    providedIn: "root"
})
export class SurveyAuditorService extends BaseService {
    private url = environment.BaseUrl + "survey-auditor";
    private hasCompletedSurveySubject = new Subject<boolean>();
    hasCompletedSurvey$ = this.hasCompletedSurveySubject.asObservable();

    private sessionStorage = inject(SessionStorageService);
    private auditor: Auditor = this.sessionStorage.get("auditor");
    private http = inject(HttpClient);

    addSurveyAuditor(surveyAuditorPost: SurveyAuditor): Observable<any> {
        const hasCompletedSurvey = Boolean(surveyAuditorPost.hasCompletedSurvey); // Converte para boolean

        return this.http
            .post(`${this.url}`, surveyAuditorPost, this.getHeader(this.auditor.idiomaAuditorInterface))
            .pipe(
                tap((result) => {
                    // Lógica que será executada após o POST ser concluído (se necessário)
                    // Neste exemplo, atualizamos o hasCompletedSurvey no SessionStorage
                    this.hasCompletedSurveySubject.next(hasCompletedSurvey);
                })
            );
    }

    getAllSurveyAuditors(): Observable<SurveyAuditor[]> {
        return this.http.get<SurveyAuditor[]>(this.url, this.getHeader(this.auditor.idiomaAuditorInterface));
    }

    delete(codAuditor: number): Observable<any> {
        return this.http.delete(`${this.url}/${codAuditor}`, this.getHeader(this.auditor.idiomaAuditorInterface));
    }
}
